import { push } from '@lagunovsky/redux-react-router'
import HomeAction from 'home/actions/HomeAction'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { H_QUALITO_CAMPAIGN } from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import DashboardCampaigns from '../../../campaign/components/DashboardCampaigns'
import ProgressCard from '../../../components/card/ProgressCard'
import { PATH_QUALITY, PATH_QUALITY_CAMPAIGN } from '../../../home/constants/RouteConstants'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import { QualityActionConstant } from 'quality/reducers/QualityReducer'
import useTitle from 'utils/customHook/useTitle'
import useAbortController from 'utils/customHook/useAbortController'
import { orderBy } from 'lodash'
import { getTimestamp } from 'utils/DateUtil'

const QualityCampaigns = () => {
    const dispatch = useDispatch()

    const [progress, setProgress] = useState(0)
    const [dataLoaded, setDataLoaded] = useState(false)

    const {
        qualitometers,
        qualityCampaigns,
        qualityCampaignsProgress,
    } = useSelector(store => ({
        qualitometers: store.QualityReducer.qualitometersLight,
        qualityCampaigns: store.QualityReducer.qualityCampaigns,
        qualityCampaignsProgress: store.QualityReducer.qualityCampaignsProgress,
    }), shallowEqual)

    useEffect(() => {
        if (!componentHasHabilitations(H_QUALITO_CAMPAIGN)) { // A modifier quand react-router sera à jour
            dispatch(push('/unauthorized'))
            return
        }
        dispatch(HomeAction.setHelpLink('qualite', ''))
        dispatch(CampaignAction.loadQualityCampaigns(setProgress)).then(() => setDataLoaded(true))
    }, [])

    useTitle(() => [{
        title: i18n.quality,
        href: PATH_QUALITY,
    }, {
        title: i18n.campaigns,
        href: PATH_QUALITY_CAMPAIGN,
    }], [])

    const {
        controllerRef,
        initController,
    } = useAbortController()

    useEffect(() => {
        initController()

        if (qualityCampaigns.length) {
            dispatch(CampaignAction.getCampaignProgressSequentially('quality', qualityCampaigns, controllerRef.current.signal))
        }
        return () => dispatch(QualityActionConstant.receiveQualityCampaignsProgress([])) // reset campaign stats progress on unmount
    }, [qualityCampaigns, controllerRef])

    return dataLoaded ? (
        <DashboardCampaigns
            stations={qualitometers}
            campaigns={orderBy(qualityCampaigns, c => getTimestamp(c.beginningApplication), 'desc')}
            campaignsProgress={qualityCampaignsProgress}
            stationType={'quality'}
        />
    ) : (
        <ProgressCard progress={progress} />
    )
}

QualityCampaigns.propTypes = {
}

export default QualityCampaigns